import _ from "lodash";
import { getAppConfig } from "config/client.config";

export const ADD_FOLDER = "ADD_FOLDER";
export const RENAME_FOLDER = "RENAME_FOLDER";
export const UPDATE_DESCRIPTION = "UPDATE_DESCRIPTION";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const MOVE_FOLDER = "MOVE_FOLDER";
export const UPDATE_POINTS = "UPDATE_POINTS";
export const UPDATE_COINS = "UPDATE_COINS";

const _addFolder = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_FOLDER, data, err, status };
};
const _renameFolder = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: RENAME_FOLDER, data, err, status };
};
const _updateDescription = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: UPDATE_DESCRIPTION, data, err, status };
};
const _updatePoints = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return {
        type: UPDATE_POINTS,
        data,
        err,
        status,
    };
};
const _updateCoins = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: UPDATE_COINS, data, err, status };
};
const _deleteFolder = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DELETE_FOLDER, data, err, status };
};
const _moveFolder = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: MOVE_FOLDER, data, err, status };
};

const addFolder = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState, Request) => {
        let topicCreationPath = getAppConfig().endpoints.builderPaths[
            "addTopicPath"
        ].replace(":id", getState().editingCourse._id);
        return Request.fetch(topicCreationPath, {
            method: "POST",
            body: JSON.stringify({
                name:
                    "New " +
                    (getState().auth.user.license.license_type === "Biz" ||
                    getAppConfig().clientApp
                        ? "Topic"
                        : "Folder"),
                description:
                    "Put in a description of the contents of this " +
                    (getState().auth.user.license.license_type === "Biz" ||
                    getAppConfig().clientApp
                        ? "topic"
                        : "folder") +
                    ". Click to edit this...",
            }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                dispatch(
                    _addFolder(
                        "adding folder",
                        {
                            name:
                                "New " +
                                (getState().auth.user.license.license_type ===
                                    "Biz" || getAppConfig().clientApp
                                    ? "Topic"
                                    : "Folder"),
                            topicId: response._id,
                            points: response.points,
                            coins: response.coins,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const renameFolder = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    name,
    image
) => {
    return (dispatch, getState, Request) => {
        let topicUpdationPath = getAppConfig()
            .endpoints.builderPaths["updateTopicPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId);
        return Promise.resolve(
            dispatch(
                _renameFolder(
                    "renaming folder",
                    {
                        name: name,
                        topicId: topicId,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(topicUpdationPath, {
                method: "POST",
                body: JSON.stringify({
                    name: name,
                    image: image == null ? undefined : image,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {
                    return Promise.resolve(
                        dispatch(
                            _renameFolder(
                                "changing image",
                                {
                                    name: name,
                                    image: _.find(response.locations, { _id: topicId }).image,
                                    topicId: topicId,
                                },
                                null
                            )
                        )
                    );
                })
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const updateDescription = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    description
) => {
    return (dispatch, getState, Request) => {
        let topicUpdationPath = getAppConfig()
            .endpoints.builderPaths["updateTopicPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId);
        return Promise.resolve(
            dispatch(
                _updateDescription(
                    "updating folder description",
                    {
                        description: description,
                        topicId: topicId,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(topicUpdationPath, {
                method: "POST",
                body: JSON.stringify({
                    description: description,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const updatePoints = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    points
) => {
    return (dispatch, getState, Request) => {
        let topicUpdationPath = getAppConfig()
            .endpoints.builderPaths["updateTopicPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId);
        return Promise.resolve(
            dispatch(
                _updatePoints(
                    "updating folder points",
                    {
                        points: points,
                        topicId: topicId,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(topicUpdationPath, {
                method: "POST",
                body: JSON.stringify({
                    points: points,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const updateCoins = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    coins
) => {
    return (dispatch, getState, Request) => {
        let topicUpdationPath = getAppConfig()
            .endpoints.builderPaths["updateTopicPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId);
        return Promise.resolve(
            dispatch(
                _updateCoins(
                    "updating folder coins",
                    {
                        coins: coins,
                        topicId: topicId,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(topicUpdationPath, {
                method: "POST",
                body: JSON.stringify({
                    coins: coins,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const deleteFolder = /* istanbul ignore next - redux passthrough function */ (
    topicId
) => {
    return (dispatch, getState, Request) => {
        let topicDeletionPath = getAppConfig()
            .endpoints.builderPaths["deleteTopicPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId);
        return Request.fetch(topicDeletionPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                dispatch(
                    _deleteFolder(
                        "deleting folder",
                        {
                            topicId: topicId,
                            size: 0,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                return err;
            });
    };
};
const moveFolder = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    direction
) => {
    return (dispatch, getState, Request) => {
        let reorderTopicsPath = getAppConfig()
            .endpoints.builderPaths["reorderTopicsPath"].replace(
                ":course_id",
                getState().editingCourse._id
            )
            .replace(":id", topicId)
            .replace(":direction", direction);
        return Promise.resolve(
            dispatch(
                _moveFolder(
                    `moving folder ${direction}`,
                    {
                        topicId: topicId,
                        direction: direction,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(reorderTopicsPath, {
                method: "POST",
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

class FolderEditorAction {
    static addFolder = addFolder;
    static renameFolder = renameFolder;
    static deleteFolder = deleteFolder;
    static moveFolder = moveFolder;
    static updateDescription = updateDescription;
    static updatePoints = updatePoints;
    static updateCoins = updateCoins;
}

export default FolderEditorAction;
